module.exports = __webpack_public_path__ + "img/hic-liver-cancer-female.b7c92d2f.png";